import { useMountEffect } from "@react-hookz/web";

/** Do not update scrollRestoration value on homepage */
const excludedPathnames = new Set(["/"]);

/**
 * For handling the advertisement issue in mobile safari
 */
export const useDisableScrollRestoration = () => {
  useMountEffect(() => {
    if (excludedPathnames.has(window.location.pathname)) {
      return;
    }
    history.scrollRestoration = "manual";
  });
};
